module.exports = __webpack_public_path__ + "26d193d43651a9965c46436a3b9377b6.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/headers/foundation.jpg
 ** module id = 422
 ** module chunks = 0
 **/